<template>
  <div class="scroller">
    <div class="list">
      <div class="list__heading">
        <h2>Users</h2>
        <router-link :to="{ name: 'users.create'}" class="btn btn--primary btn--small">
            NEW USER
        </router-link>
      </div>

      <Loader v-if="isLoading" />
      <div class="listData" v-for="user in users.data" :key="user.id" v-else>
        <router-link :to="{ name: 'users.edit', params: { id: user.id }}" class="listData__link" @click="setSize()">
          <div class="listData__item">
            <h3 class="listData__heading mb0">{{ user.name }} {{ user.surname }}</h3>
          </div>
        </router-link>
        <button class="listData__delete" @click="deleteUser(user)">
          <font-awesome-icon :icon="['fal', 'trash-alt']"/>
        </button>
      </div>
    </div>
    <Pagination :pagination="users.pagination" :Resource="user" :type="types.GET_ALL_USERS" :isLoading="types.IS_LOADING_USERS"/>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import User from '@/model/User'
import Loader from '@/components/Utils/Loader'
import Pagination from '@/components/Utils/Pagination'
import {loadResource, deleteResource} from '@/helpers/resource'

export default {
  computed: {
    users () {
      return this.$store.getters[types.ALL_USERS]
    },
    isLoading () {
      return this.$store.getters[types.IS_LOADING_USERS]
    },
    types () {
      return types
    },
    user () {
      return User
    }
  },
  components: {
    Loader, Pagination
  },
  mounted () {
    loadResource(User, types.GET_ALL_USERS, types.IS_LOADING_USERS)
  },
  methods: {
    deleteUser (user) {
      deleteResource(types.REMOVE_USER, user)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/UserList.vue